import axios from "axios";

const BASE_ROUTE = "concierge-calls";

/** Catalogos del seguimiento: { callTypes, responseTypes, responders, contactMedia }, cada uno [{ code, label }]. */
export const getConciergeCatalogs = () => axios.get(`${BASE_ROUTE}/catalogs`);

/** Llamadas registradas del caso, de la mas reciente a la mas antigua. */
export const getConciergeCalls = (caseId) => axios.get(`${BASE_ROUTE}/${caseId}`);

/**
 * Registra una llamada. El API tambien deja su comentario en la bitacora del caso. Los errores de
 * captura (400) llegan como rechazo con el mensaje en error.response.data.
 */
export const saveConciergeCall = (caseId, data) => axios.post(`${BASE_ROUTE}/${caseId}`, data);
